import { render, staticRenderFns } from "./ProductCategorySidebar.vue?vue&type=template&id=23f70003"
import script from "./ProductCategorySidebar.vue?vue&type=script&lang=js"
export * from "./ProductCategorySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports